<section class="business-price-detail-list-wrapper">
  <div class="promotion-wrapper mobile">
    <div class="promotion">
      <div class="promotion__text" [innerHTML]="'BUSINESS_REGISTRATION.PROMOTION_LIST.PROMOTION.TEXT' | translate">
      </div>
      <ng-container *ngFor="let item of ServiceList">
        <div class="promotion__price"
          ><span class="blue-text">{{ item.data.price.iv }}.-</span>
          <div class="del-text"
            >{{ 'BUSINESS_REGISTRATION.PROMOTION_LIST.PROMOTION.FROM_TEXT' | translate }}
            <del>{{ item.data.normalPrice.iv }}.</del>-
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="box-wrapper">
    <ng-container *ngFor="let business of BusinessList">
      <div class="box">
        <div class="box__heading">{{
          translate.currentLang === 'th' ? business.data.title.th : business.data.title.en
        }}</div>
        <ul class="box__text">
          <span [innerHTML]="translate.currentLang === 'th' ? business.data.detail.th : business.data.detail.en"></span>
        </ul>
      </div>
    </ng-container>
  </div>

  <div class="promotion-wrapper desktop">
    <div class="promotion">
      <div class="promotion__text" [innerHTML]="'BUSINESS_REGISTRATION.PROMOTION_LIST.PROMOTION.TEXT' | translate">
      </div>
      <ng-container *ngFor="let item of ServiceList">
        <div class="promotion__price"
          ><span class="blue-text">{{ item.data.price.iv }}.-</span>
          <div class="del-text"
            >{{ 'BUSINESS_REGISTRATION.PROMOTION_LIST.PROMOTION.FROM_TEXT' | translate }}
            <del>{{ item.data.normalPrice.iv }}.</del>-
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
